const OVERLAY_ID = 'famla-mapping-nav-overlay';

const STORAGE_KEYS = {
    interviewDeferredMap: 'famla-interview-deferred-map',
    interviewCalculateDone: 'famla-interview-calculate-done-maps',
} as const;

/** Temps minimum pour lire l'écran de chargement (animation + pleaseWait). */
export const INTERVIEW_MAPPING_MIN_READ_MS = 22000;

/** Attente max des stats avant révélation si le chargement est très rapide. */
export const INTERVIEW_MAPPING_STATS_WAIT_MS = 2800;

/** Délai max d'attente du canvas avant révélation (évite overlay infini). */
export const INTERVIEW_MAPPING_EDITOR_FALLBACK_MS = 12000;

/** Marque une ouverture interview (Macro, V1, V2…) devant garder l'écran noir. */
export function markInterviewDeferredMappingOpen(mapId: string): void {
    if (!mapId || typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem(STORAGE_KEYS.interviewDeferredMap, mapId);
}

export function isInterviewDeferredMappingOpen(mapId: string | undefined): boolean {
    if (!mapId || typeof sessionStorage === 'undefined') return false;
    return sessionStorage.getItem(STORAGE_KEYS.interviewDeferredMap) === mapId;
}

export function clearInterviewDeferredMappingOpen(): void {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.removeItem(STORAGE_KEYS.interviewDeferredMap);
}

function readInterviewCalculateDoneIds(): Set<string> {
    if (typeof localStorage === 'undefined') return new Set();
    try {
        const raw = localStorage.getItem(STORAGE_KEYS.interviewCalculateDone);
        if (!raw) return new Set();
        const parsed = JSON.parse(raw);
        return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
    } catch {
        return new Set();
    }
}

/** True après un premier GET calculate/new réussi pour cette carto (persistant navigateur). */
export function isInterviewCalculateDone(mapId: string | undefined): boolean {
    if (!mapId) return false;
    return readInterviewCalculateDoneIds().has(String(mapId));
}

export function markInterviewCalculateDone(mapId: string): void {
    if (!mapId || typeof localStorage === 'undefined') return;
    const ids = readInterviewCalculateDoneIds();
    ids.add(String(mapId));
    try {
        localStorage.setItem(STORAGE_KEYS.interviewCalculateDone, JSON.stringify([...ids]));
    } catch {
        /* quota */
    }
}

/** Écran noir — persiste pendant la transition vers ProcessDiagram. */
export function showMappingLoadingOverlay(): void {
    if (typeof document === 'undefined') return;
    let el = document.getElementById(OVERLAY_ID);
    if (!el) {
        el = document.createElement('div');
        el.id = OVERLAY_ID;
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-busy', 'true');
        el.className = 'bg-dark position-fixed top-0 start-0 w-100 vh-100';
        el.style.zIndex = '200000';
        document.body.appendChild(el);
    }
    el.style.display = 'block';
}

export function hideMappingLoadingOverlay(): void {
    document.getElementById(OVERLAY_ID)?.remove();
}

export function waitForOverlayPaint(): Promise<void> {
    return new Promise((resolve) => {
        requestAnimationFrame(() => resolve());
    });
}
